<template>
  <div>
    <el-table-column
      :label="label"
      :prop="prop"
      align="center"
      :sortable="sortable"
      :show-overflow-tooltip="showOverflowTooltip"
      :min-width="minWidth"
      :data-isTotal="dataIsTotal"
    >
      <el-table-column
        align="left"
        :prop="prop"
        :width="minWidth"
        :show-overflow-tooltip="showOverflowTooltip"
        label-class-name="my-table-column"
      >
        <template #header>
          <div class="glo_disFlex">
            <el-input
              class="filter-input"
              type="text"
              @input="onHeaderCheckSearch()"
              clearable
              v-model="keyword"
              placeholder="请输入"
            />
            <i
              v-if="TableDataALl.length > 0"
              @click="openGroup"
              class="el-icon-s-unfold glo_tbSelectIcon"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table-column>
    <!-- 表格搜索弹窗 -->
    <myDialog
      :diaWidth="diaWidthA"
      :dialogTitle="dialogTitleA"
      :isShowDialog="isShowDialogA"
      :showCacel="false"
      :showConfirm="false"
      :dialogFooter="false"
      :isCloseModal="true"
      @handleCloseDia="isShowDialogA = false"
      :isAppend="true"
    >
      <el-checkbox-group v-model="checkList" @change="changeGroupList">
        <el-checkbox
          class="TBcheckBoxItem"
          v-for="(itemA, idxA) in groupList"
          :key="idxA"
          :label="itemA.name"
        >
          {{ itemA.name }} ({{ itemA.number }})
        </el-checkbox>
      </el-checkbox-group>
    </myDialog>
  </div>
</template>

<script>
import myDialog from "@/components/Dialog.vue";
export default {
  components: {
    myDialog,
  },
  props: {
    label: {},
    prop: {},
    align: {
      default: "center",
    },
    sortable: {
      default: false,
    },
    showOverflowTooltip: {
      default: false,
    },
    minWidth: {},
    dataIsTotal: {},
  },
  data() {
    return {
      // 统一加上
      diaWidthA: "260px",
      dialogTitleA: "",
      isShowDialogA: false,
      groupKey: "",
      groupList: [],
      checkList: [],
      keyword: ""
    };
  },
  computed: {
    TableDataALl() {
      return this.$parent.data;
    },
  },
  methods: {
    filterHandler(value, row, column) {
        // 清空2，需要全部返回
        if(!value){
            return true
        }
      const property = column["property"];
      return row[property] && row[property].indexOf(value) != -1;
    },
    // 打开搜索弹窗
    openGroup() {
      let val = this.prop;

      let oldData = JSON.parse(JSON.stringify(this.TableDataALl));
      let arrs = [];
      oldData.forEach((item) => {
        if (item[val]) {
          let objs = {
            name: item[val],
            field: val,
          };
          arrs.push(objs);
        }
      });
      //  去重
      let uniqueList = arrs.reduce((acc, cur) => {
        if (!acc.find((item) => item.name === cur.name)) {
          acc.push(cur);
        }
        return acc;
      }, []);
      uniqueList.forEach((itemA) => {
        itemA.number = 0;
        arrs.forEach((itemB) => {
          if (itemA.name == itemB.name) {
            itemA.number++;
          }
        });
      });
      this.groupList = uniqueList;
    
      this.checkList = [];
      this.dialogTitleA = this.label;
      this.isShowDialogA = true;
    },
    changeGroupList(e) {
      let str = e.join(",");
      this.keyword = str
      this.onHeaderCheckSearch(e);
    },
    // 标题输入搜索
    onHeaderCheckSearch(keyword) {
      if (!keyword) {
        keyword = this.keyword.split(',')
      }
      this.confirmFilter(keyword);
    },

    confirmFilter(values) {
      const columnConfig = this.$children[0].columnConfig;
      const column = this.$parent.columns.filter(
        (item) => item.property === columnConfig.property
      )[0];
      column.filterMethod = this.filterHandler;
      this.$parent.store.commit("filterChange", {
        column,
        values,
      });
      this.$parent.store.updateAllSelected();
    },
  },
};
</script>

<style scoped lang='less'>
.filter-input {
  /deep/ .el-input__suffix {
    display: flex;
    align-items: center;
  }
}
</style>
<style lang='less'>
.my-table-column {
  .el-table__column-filter-trigger {
    display: none;
  }
}
</style>